export default {
  applicationName: 'SiteReadyBC',
  organizationName: 'BCCSA',
  websiteLabel: 'bccsa.ca',
  websiteLink: 'https://www.bccsa.ca/',
};
